module.exports = __webpack_public_path__ + "img/down-red-envelope.d183ac85.png";